module.exports = __webpack_public_path__ + "img/thumbnail_WildWaterBuffalo_m_normal.7166e7b9.png";